import React, { Component } from 'react'

import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import { withStyles } from '@mui/styles'

import { KEY_VALUES, COLOR } from "../../modules/constants"

const styles = theme => ({
  text: {
    whiteSpace: 'pre-wrap'
  },
})

class MaxApptsModal extends Component {

  render() {
    const title = "Warning!"
    const content1 = `This officer has about ${this.props.totalResults} current and past appointments - more than Numerable's limit of ${KEY_VALUES.MAX_APPTS}, so some appointments may be missing`
    const content2 = "Please research this officer directly at Companies House"

    return (
      <Dialog open={Boolean(this.props.open)} onClose={this.props.onClose} maxWidth="sm" fullWidth>
        <DialogTitle style={{color: COLOR.WARN}}>{title}</DialogTitle>
        <DialogContent>{content1}</DialogContent>
        <DialogContent>{content2}</DialogContent>
        <DialogContent>
          Click OK to continue
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose} color="primary" variant="contained">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default withStyles(styles)(MaxApptsModal);

